/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompletedExercise } from './CompletedExercise';
import {
    CompletedExerciseFromJSON,
    CompletedExerciseFromJSONTyped,
    CompletedExerciseToJSON,
    CompletedExerciseToJSONTyped,
} from './CompletedExercise';

/**
 * 
 * @export
 * @interface CompletedRound
 */
export interface CompletedRound {
    /**
     * 
     * @type {Array<CompletedExercise | null>}
     * @memberof CompletedRound
     */
    exercises: Array<CompletedExercise | null>;
}

/**
 * Check if a given object implements the CompletedRound interface.
 */
export function instanceOfCompletedRound(value: object): value is CompletedRound {
    if (!('exercises' in value) || value['exercises'] === undefined) return false;
    return true;
}

export function CompletedRoundFromJSON(json: any): CompletedRound {
    return CompletedRoundFromJSONTyped(json, false);
}

export function CompletedRoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletedRound {
    if (json == null) {
        return json;
    }
    return {
        
        'exercises': ((json['exercises'] as Array<any>).map(CompletedExerciseFromJSON)),
    };
}

export function CompletedRoundToJSON(json: any): CompletedRound {
    return CompletedRoundToJSONTyped(json, false);
}

export function CompletedRoundToJSONTyped(value?: CompletedRound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exercises': ((value['exercises'] as Array<any>).map(CompletedExerciseToJSON)),
    };
}

